import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HealthIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HealthIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M13.5908 14.1094H12.0283V15.6719H13.5908V14.1094Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.4658 10.9844H8.90332V12.5469H10.4658V10.9844Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.4658 14.1094H8.90332V15.6719H10.4658V14.1094Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.1533 6.29688H13.5908V4.73438H12.0283V6.29688H10.4658V7.85938H12.0283V9.42188H13.5908V7.85938H15.1533V6.29688Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.4658 6.29688H19.8408V4.34375C19.8408 3.05141 18.7894 2 17.4971 2H8.12207C6.82973 2 5.77832 3.05141 5.77832 4.34375V6.29688H5.15332C3.86098 6.29688 2.80957 7.34828 2.80957 8.64062V22H11.2471V18.7969H14.3721V22H22.8096V8.64062C22.8096 7.34828 21.7582 6.29688 20.4658 6.29688ZM5.77832 20.4375H4.37207V8.64062C4.37207 8.20984 4.72254 7.85938 5.15332 7.85938H5.77832V20.4375ZM18.2783 20.4375H15.9346V17.2344H9.68457V20.4375H7.34082V4.34375C7.34082 3.91297 7.69129 3.5625 8.12207 3.5625H17.4971C17.9279 3.5625 18.2783 3.91297 18.2783 4.34375V20.4375ZM21.2471 20.4375H19.8408V7.85938H20.4658C20.8966 7.85938 21.2471 8.20984 21.2471 8.64062V20.4375Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.7158 10.9844H15.1533V12.5469H16.7158V10.9844Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.5908 10.9844H12.0283V12.5469H13.5908V10.9844Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.7158 14.1094H15.1533V15.6719H16.7158V14.1094Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HealthIcon;
